import type { SessionPolicy } from './use-session-policy';

/** What the server said about the session on the response that just landed. */
export type SessionClockUpdate = {
  expiresAt?: number;
  policy?: SessionPolicy;
};

const expiresInHeader = 'x-session-expires-in-ms';
const idleTimeoutHeader = 'x-session-idle-timeout-hours';
const warningMinutesHeader = 'x-session-warning-minutes';

function readNumber(headers: Headers, name: string): number | undefined {
  let value: number | undefined = undefined;
  const raw = headers.get(name);
  if (raw !== null && raw.length > 0) {
    const parsed = Number(raw);
    if (Number.isFinite(parsed)) {
      value = parsed;
    }
  }
  return value;
}

/**
 * Reads the session clock the middleware stamps on every authenticated response:
 * the row's remaining time (converted to this browser's clock the moment it landed)
 * and the organization's idle policy.
 */
export function readSessionClock(headers: Headers): SessionClockUpdate {
  const update: SessionClockUpdate = {};
  const expiresInMs = readNumber(headers, expiresInHeader);
  if (expiresInMs !== undefined) {
    update.expiresAt = Date.now() + expiresInMs;
  }
  const idleTimeoutHours = readNumber(headers, idleTimeoutHeader);
  const warningMinutes = readNumber(headers, warningMinutesHeader);
  if (idleTimeoutHours !== undefined && warningMinutes !== undefined) {
    update.policy = { idleTimeoutHours: idleTimeoutHours, warningMinutes: warningMinutes };
  }
  return update;
}
